import { calculateIcebergPercentForER } from "./icebergHelpers";
import { getCPFromStore } from "../../tradeLookupHelpers";

/**
 * AG Grid valueFormatter for copy/paste. Returns the rounded percentage with
 * a trailing space (no `%` symbol — that lives only in the renderer), or empty
 * string when the cell renders blank.
 *
 * Reads from the live Zustand store first to match what the user sees;
 * falls back to params.data when the store entry is missing.
 */
export function icebergValueFormatter(params: any): string {
  const liveCP = getCPFromStore(
    params?.data?.esid ?? params?.context?.fullTradeData?.esid,
    params?.data?.executionRequestId,
  );
  const cp = liveCP ?? params?.data;
  const percent = calculateIcebergPercentForER(cp);
  if (percent === null) return "";
  return `${Math.round(percent)} `;
}
